module.exports = __webpack_public_path__ + "img/hvac-mechanical-maintenance-05-tablet.606ba666.jpg";